import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-regular-svg-icons";
import { useLocation } from "react-router-dom";
import "./Header.css";
import profile from "../../Assets/profile.svg";
import MoSidebar from "../Sidebar/MoSidebar";
import Logo from "../../Assets/logo.svg";

const Header = ({ setIsSidebarOpen }) => {
  const [isSidebarOpenLocal, setIsSidebarOpenLocal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Automatically close the sidebar when the screen width is smaller than 1024px
    if (window.innerWidth < 1024) {
      setIsSidebarOpen(false);
    }
  }, [window.innerWidth]);

  const getPageTitle = () => {
    const path = location.pathname;
    const pathSegments = path.split("/").filter((segment) => segment !== "");
    const lastSegment = pathSegments[pathSegments.length - 1];

    switch (lastSegment.toLowerCase()) {
      default:
        return (
          lastSegment.charAt(0).toUpperCase() +
          lastSegment.slice(1).toLowerCase()
        );
    }
  };

  return (
    <>
      <header className="header">
        <div className="header-left">
          {!isSidebarOpenLocal && (
            <span
              className="hamburger"
              onClick={() => setIsSidebarOpenLocal(true)}
            >
              ☰
            </span>
          )}
          <div className="mobilelogo">
            <img src={Logo} alt="logo" />
          </div>
          <span className="header-text">{getPageTitle()}</span>
        </div>
        <div className="header-right">
          <span className="notification">
            <FontAwesomeIcon icon={faBell} className="bell-icon" />
          </span>
          <img src={profile} alt="Profile" className="profile-img" />
        </div>
      </header>
      <div style={{ display: isSidebarOpenLocal ? "block" : "none" }}>
        <MoSidebar closeSidebar={() => setIsSidebarOpenLocal(false)} />
        {/* //{" "}
        {isSidebarOpenLocal && (
          <MoSidebar closeSidebar={() => setIsSidebarOpenLocal(false)} />
        )} */}
      </div>
    </>
  );
};

export default Header;
